<div class="w-full p-5 rounded-2xl flex justify-between bg-white border-[1px] border-border shadow-md min-h-[100px]"
    *ngIf="visible">
    <div class="flex flex-col gap-2 text-warning-600">
        <h1 class="font-bold">{{ header | transloco }}</h1>
        <p>{{ description | transloco }}</p>
    </div>

    <div class="text-warning hover:text-black hover:cursor-pointer" (click)="visible = !visible">
        <svg width="25px" height="25px" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path fill="currentColor"
                d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z" />
        </svg>
    </div>
</div>